export { showModalRegisterInfo } from './register-info';
